<template>
  <div class="container">
    <div class="concentratorList_main">
      <iframe
        id="iframeContain"
        name="iframeContain"
        seamless
        scrolling="no"
        :src="'https://jk.taiott.com/#/login?isLogin=1&redirect=/concentratorManagement/concentratorList&user='+$store.state.user.name"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
    </div>
  </div>
</template>
<script>
export default {  
  data () {
    return {
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>
<style scoped>
.container {
	position: relative;
	width: 100%;
	height:100%;
	background:#191923;
}
.concentratorList_main{
	position: absolute;
	top:-60px;
	left:0;
	right:0;
	bottom:0;
	overflow: hidden;
}

#iframeContain{
	width: 100%;
	height: 100%;
	border: 0;
	padding: 0;
	margin:0;
}
</style>